export enum RequestStatus {
    'idle',
    'loading',
    'succeeded',
    'failed',
}
